import { useT } from "../../../shared/i18n/i18n";
import type { WorkObjectFieldAuditEvent } from "../model/use-work-object-field-audit";
import { Skeleton } from "@/components/ui/skeleton";

type WorkObjectFieldAuditListProps = {
  events: WorkObjectFieldAuditEvent[];
  isLoading: boolean;
};

export function WorkObjectFieldAuditList({ events, isLoading }: WorkObjectFieldAuditListProps) {
  const t = useT();
  return (
    <section className="flex flex-col gap-2 rounded-lg bg-muted/20 p-3">
      <div>
        <h3 className="text-sm font-medium">{t("fields.history")}</h3>
        <p className="mt-1 text-xs text-muted-foreground">{t("fields.recentChangesHint")}</p>
      </div>
      {isLoading ? <Skeleton className="h-14 w-full" /> : null}
      {!isLoading && events.length === 0 ? <p className="text-sm text-muted-foreground">{t("fields.noChanges")}</p> : null}
      {!isLoading && events.length > 0 ? (
        <div className="flex flex-col gap-2">
          {events.map((event) => (
            <div key={event.id} className="rounded-md bg-card p-2">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-medium">{labelForEvent(event.eventType)}</p>
                <time className="text-xs text-muted-foreground">{new Date(event.createdAt).toLocaleString()}</time>
              </div>
              <p className="mt-1 text-xs text-muted-foreground">{event.actorEmail ?? "Unknown actor"}</p>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}

function labelForEvent(eventType: WorkObjectFieldAuditEvent["eventType"]) {
  if (eventType === "field_definition_created") {
    return "Created";
  }
  if (eventType === "field_definition_renamed") {
    return "Renamed";
  }
  if (eventType === "field_definition_archived") {
    return "Archived";
  }

  return "Changed";
}
